/**
 * The signal stack, rendered from the brand colour at runtime so a
 * white-labelled instance shows the client's mark, not ours.
 */
export const Mark = ({ size = 32 }: { readonly size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    role="img"
    aria-label="Kestrelay"
    style={{ borderRadius: size * 0.22, background: 'var(--brand)' }}
  >
    <g
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 10 L12 5 L20 10" />
      <path d="M7 14 L12 10 L17 14" />
    </g>
    <circle cx="12" cy="18.5" r="1.5" fill="#fff" />
  </svg>
);
